import { Button } from "antd";
import { FormattedMessage, useIntl } from "react-intl";
import Icon from "../Icon/Icon";
import { Props } from "./CreateVideoFeedback.model";
import { useCreateVideoFeedback } from "./useCreateVideoFeedback";
import styles from './CreateVideoFeedback.module.scss';
import Popup from "../Popup/Popup";
import TextArea from "antd/lib/input/TextArea";
import { Controller } from "react-hook-form";
import { useHistory } from "react-router";


const CreateVideoFeedback = ({ isOrganizer, onClose }: Props) => {

	const {
		control,
		handleSubmit,
		setRating,
		setStep,
		state: {
			rating,
			step
		},
		submitFeedback
	} = useCreateVideoFeedback();

	const intl = useIntl();

	const history = useHistory();

	const renderStep1 = () => {
		return <>
			{isOrganizer && <p><FormattedMessage id="media.savedRecordings" values={{ b: (...chunks: any) => <b>{chunks}</b> }} /></p>}
			<div className={styles.icon}><Icon name="video" width="100px" height="100px" color="primary" type="light" /></div>
			<h1><FormattedMessage id="videoFeedback.step1.title" /></h1>
			<p><FormattedMessage id="videoFeedback.step1.info" /></p>
			<Button type="primary" size="large" onClick={() => { setStep(2) }}>
				<FormattedMessage id="buttons.rateExperience" />
			</Button>
		</>
	}

	const renderStars = (rating: number) => {
		const ratings = [1, 2, 3, 4, 5];
		return ratings.map(i => {
			if (i <= rating) return <span onClick={() => { setRating(i) }} key={i}><Icon name="star" type="solid" color="orange" width="50px" height="50px" /></span>
			return <span onClick={() => { setRating(i) }} key={i}><Icon name="star" type="light" color="orange" width="50px" height="50px" /></span>
		})
	}

	const renderStep2 = () => {
		return <>
			<h3><FormattedMessage id="videoFeedback.step2.subtitle" /></h3>
			<h1><FormattedMessage id="videoFeedback.step2.title" /></h1>
			<p><FormattedMessage id="videoFeedback.step2.info" /></p>
			<div className={styles.stars}>
				<div className={styles.starsWrapper}>{renderStars(rating)}</div>
				<span><FormattedMessage id="videoFeedback.veryBad" /></span>
				<span><FormattedMessage id="videoFeedback.veryGood" /></span>
			</div>
			<div className={styles.fieldWrapper}>
				<span className={styles.floatingLabel}>
					<FormattedMessage id="formLabels.why" />
					</span>
				<Controller
					name="description"
					control={control}
					render={({ field }) => <TextArea {...field} rows={8} placeholder={ intl.formatMessage({id: "videoFeedback.placeholder"})}/>}
				/>
			</div>
		</>
	}

	const renderStep3 = () => {
		return <div className={styles.finishReview} >
			<div className={`${styles.content} ${styles.scrollable}`}>
				<span className={styles.closeIcon} onClick={onClose}>
					<Icon name='times' color='black' />
				</span>
				<Icon className={styles.icon} color="green" name="badge-check" type="light" />
				<h1><FormattedMessage id="ratings.thankYou.title" /></h1>
				<Button type="link" onClick={() => { onClose(); history.push("/calendar"); }}><FormattedMessage id="ratings.thankYou.link" /></Button>
			</div>
		</div>
	}

	return <Popup onClose={onClose} size="extra-small" height="full-height" actions={step === 2 ? <Button type="primary" size="large" onClick={handleSubmit(submitFeedback)}><FormattedMessage id="buttons.continue" /></Button> : undefined}>
		<><div className={styles.popupContent}>
			{step === 1 && renderStep1()}
			{step === 2 && renderStep2()}
		</div>
			{step === 3 && renderStep3()}
			</>
	</Popup>
}

export default CreateVideoFeedback;